import PropTypes from 'prop-types'
import clsx from 'clsx'
import {
  Drawer,
  Dialog,
  DialogContent,
  DialogActions,
  Typography,
  Box,
} from '@mui/material'

import useIsMobile from '../../../hooks/useIsMobile'
import useStyles from './styles'
import { ReactComponent as Warning } from '../../../assets/icons/warning.svg'
import { ReactComponent as Close } from '../../../assets/icons/x.svg'

const ModalLayout = ({
  header,
  title,
  content,
  extraContent,
  withIconAlert,
  actions,
  onClose,
  isOpen,
  wide,
  closeButton,
  anchor = 'top',
  sx,
}) => {
  const isMobile = useIsMobile()
  const classes = useStyles()

  return (
    <>
      {isMobile ? (
        <Drawer anchor={anchor} open={isOpen} onClose={onClose}>
          {header ? header : null}
          <Box className={classes.infoContainerMobile}>
            <Typography variant="h2" className={classes.titleMobile}>
              {title}
            </Typography>
            <Typography variant="body1" color="neutral.main">
              {content}
            </Typography>
          </Box>
          {extraContent ? extraContent : null}
          {actions ? actions : null}
        </Drawer>
      ) : (
        <Dialog
          open={isOpen}
          disablePortal
          onClose={onClose}
          className={clsx({
            [classes.dialogIconAlert]: !!withIconAlert,
            [classes.emptyContent]: content === undefined,
            [classes.wide]: !!wide,
          })}
          sx={sx}
        >
          {header ? header : null}
          {withIconAlert ? (
            <Box className={classes.dialogIconAlertBoxIcon}>
              <Warning />
            </Box>
          ) : null}
          <DialogContent>
            {closeButton ? (
              <Close onClick={onClose} className={classes.closeIcon} />
            ) : null}
            {title ? (
              <Typography
                variant="h2"
                sx={{
                  mb: 4,
                }}
                className={clsx('decorator', 'secondaryTitle')}
              >
                {title}
              </Typography>
            ) : null}
            {content ? (
              <Typography
                sx={{
                  color: 'neutral.main',
                }}
                variant="subtitle2"
              >
                {content}
              </Typography>
            ) : null}
            {extraContent ? extraContent : null}
            {actions ? <DialogActions>{actions}</DialogActions> : null}
          </DialogContent>
        </Dialog>
      )}
    </>
  )
}

ModalLayout.propTypes = {
  header: PropTypes.node,
  title: PropTypes.string.isRequired,
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  extraContent: PropTypes.node,
  actions: PropTypes.node,
  onClose: PropTypes.func,
  withIconAlert: PropTypes.bool,
  isOpen: PropTypes.bool,
  wide: PropTypes.number,
  anchor: PropTypes.string,
  sx: PropTypes.object,
}

export default ModalLayout
